import { Outlet } from "react-router-dom";

type Props = {};
export default function Uncert(props: Props) {
  return (
    <div className="min-h-screen min-w-screen bg-white flex flex-col justify-between">
      <Outlet />
    </div>
  );
}
